/** @jsx jsx */
import { jsx, Button, Flex } from 'theme-ui';

const Buttons = ({ justifyContent, buttons, builderBlock }) => (
  <Flex
    sx={{
      flexDirection: ['column', 'column', 'row'],
      flexWrap: 'wrap',
      justifyContent,
    }}
  >
    {buttons.map((b) => (
      <Button
        as="a"
        key={`${builderBlock.id}-${b.linkUrl}`}
        href={b.linkUrl}
        variant={b.variant}
        sx={{
          // For backwards compatibility
          textTransform: (b.uppercase === false ? 'none' : 'uppercase'),
        }}
      >
        {b.label}
      </Button>
    ))}
  </Flex>
);

export default Buttons;
